let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class SlidersT1Controller{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
    this.myInterval=7000;
    this.noWrapSlides=false;
    this.noPause=true;
  }

}

SlidersT1Controller.$inject = inject;

export default SlidersT1Controller;




// WEBPACK FOOTER //
// ./www/components/home/sliders/sliders-t1/sliders-t1.controller.js